import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toggle"
export default class extends Controller {
  static targets = ["content", "icon"]
  static values = {
    target: String,
    autoOpenFirst: Boolean
  }

  connect() {
    const shouldAutoOpenFirst = this.hasAutoOpenFirstValue ? this.autoOpenFirstValue : true
    if (!shouldAutoOpenFirst) return

    // If this is the first toggle, show it by default
    if (this.element.classList.contains("to-do-toggle") && this.element === document.querySelector(".to-do-toggle:first-of-type")) {
      const target = this.hasTargetValue ? this.targetValue : this.element.getAttribute("target")
      if (target) {
        const contentElements = Array.from(document.querySelectorAll(`.open-block${target}`))
        const iconContainer = document.querySelector(`.to-do-toggle${target}`)
        if (contentElements.length > 0) {
          if (window.jQuery) {
            window.$(contentElements).show()
          } else {
            contentElements.forEach((contentElement) => {
              contentElement.style.display = ""
            })
          }
        }
        if (iconContainer) {
          this.toggleIcons(iconContainer)
        }
      }
    }
  }

  toggle(event) {
    event.preventDefault()

    // Get target from value or attribute
    const target = this.hasTargetValue ? this.targetValue : this.element.getAttribute("target")
    if (!target) return

    // Try both selector patterns: #review-row (for old_review) and .open-block (for other pages)
    const reviewRowSelector = `#review-row${target}`
    const openBlockSelector = `.open-block${target}`
    const iconSelector = `#to-do-toggle${target}`
    const iconClassSelector = `.to-do-toggle${target}`

    // Try review-row first (ID selector), then open-block (class selector)
    const reviewRowElement = document.querySelector(reviewRowSelector)
    const contentElements = reviewRowElement ? [reviewRowElement] : Array.from(document.querySelectorAll(openBlockSelector))

    // Try ID selector first, then class selector for icon
    let iconElement = document.querySelector(iconSelector)
    if (!iconElement) {
      iconElement = document.querySelector(iconClassSelector)
    }

    if (contentElements.length > 0) {
      // Use slideToggle with appropriate speed (250ms for review-row, 200ms for open-block)
      const speed = reviewRowElement ? 250 : 200
      if (window.jQuery) {
        contentElements.forEach((contentElement) => {
          window.$(contentElement).slideToggle(speed)
        })
      } else {
        // Fallback: toggle display for all matched rows.
        contentElements.forEach((contentElement) => {
          const isHidden = window.getComputedStyle(contentElement).display === "none"
          contentElement.style.display = isHidden ? "" : "none"
        })
      }
    }

    if (iconElement) {
      this.toggleIcons(iconElement)
    }
  }

  toggleIcons(iconContainer) {
    const downIcon = iconContainer.querySelector(".chevron-down")
    const upIcon = iconContainer.querySelector(".chevron-up")
    if (!downIcon || !upIcon) return

    if (window.jQuery) {
      window.$(downIcon).toggle()
      window.$(upIcon).toggle()
    } else {
      downIcon.style.display = downIcon.style.display === "none" ? "" : "none"
      upIcon.style.display = upIcon.style.display === "none" ? "" : "none"
    }
  }
}
